module.exports = __webpack_public_path__ + "media/images/icon_popup_close_on-92a81aeb012fcd864560fd23a6ffac09.png";